import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AppGlobals } from '@app/app.global';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  constructor(private appGlobals: AppGlobals) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let headers = this.appGlobals.headers;

    if (request.headers.keys().length) {
      request.headers
        .keys()
        .forEach(header => (headers = headers.set(header, request.headers.getAll(header))));
    }

    return next.handle(request.clone({ headers }));
  }
}
